<template>
    <div class="w-full flex flex-col p-8 text-ternary">
        <div class="w-full flex flex-col">
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Name</div>
                <div class="w-3/4">{{ item.user.name }}</div>
            </div>
            <div v-if="item.post_training.partner" class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Employer</div>
                <div class="w-3/4">{{ item.post_training.partner.en_company_name }}</div>
            </div>
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Post Training Title</div>
                <div class="w-3/4">{{ item.post_training.title }}</div>
            </div>
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Application Date</div>
                <div class="w-3/4">{{ getFormattedDate(item.created_at) }}</div>
            </div>
            <div class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">status</div>
                <div class="w-3/4">{{ getStatus }}</div>
            </div>
            <div v-if="item.note" class="flex flex-row flex-wrap mt-2">
                <div class="w-1/4 font-bold">Note</div>
                <div class="w-3/4">{{ item.note }}</div>
            </div>
            <div v-if="hasDocuments" class="flex flex-col mt-6">
                <h1 class="text-xl font-bold"><span class="underline">Uploaded Documents</span> ({{ this.item.post_training_application_attachments.length }})</h1>
                <div class="flex flex-col mt-2">
                    <div class="flex flex-col overflow-x-auto">
                        <div class="inline-block min-w-full py-2">
                            <div class="overflow-x-auto">
                                <table class="min-w-full text-left text-sm font-light">
                                    <thead class="border-b font-medium dark:border-neutral-500">
                                        <tr>
                                            <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                            <th scope="col" class="px-6 py-2 text-gray-400">Name</th>
                                            <th scope="col" class="px-6 py-2 text-gray-400">View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in uploadedDocuments" :key="index" class="border-b border-dashed dark:border-neutral-500">
                                            <td class="whitespace-nowrap px-6 py-2 font-medium">{{ index + 1 }}</td>
                                            <td class="whitespace-nowrap px-6 py-2 font-medium">Document {{ index + 1 }}</td>
                                            <td class="whitespace-nowrap px-6 py-2">
                                                <div @click.stop="setDocumentPreview(`Document ${index + 1}`, item.url)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                    <icon-eye class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade" mode="out-in">
            <base-full-modal v-if="showDocumentPreview" :title="`View ${documentName}`" @close="closeDocumentPreview">
                <iframe v-if="documentPreview" :src="documentPreview" width="100%" :height="iframeHeight" frameborder="0"></iframe>
            </base-full-modal>
        </transition>
    </div>
</template>

<script>
import IconEye from "../../../components/icons/IconEye.vue";
import { formattedDate, formattedDateWithTimeAmPm } from "../../../helpers/utils";
export default {
    name: "view-post-training-applications",
    props: ["item", "iframeHeight"],
    components: {
        IconEye,
    },
    data() {
        return {
            documentPreview: null,
            documentName: "",
            showDocumentPreview: false,
        };
    },
    computed: {
        getStatus() {
            if (this.item.status === null) {
                return "Pending";
            } else if (this.item.status === false) {
                return "Rejected";
            } else {
                return "Approved";
            }
        },
        hasDocuments() {
            return this.item.post_training_application_attachments && this.item.post_training_application_attachments.length > 0;
        },
        uploadedDocuments() {
            return this.item.post_training_application_attachments;
        },
        role() {
            return this.$store.getters.role;
        },
        getProfilePicture() {
          return process.env.VUE_APP_PUBLIC_URL + this.item.profile_picture_url;
        },
    },
    methods: {
        setDocumentPreview(documentName, url) {
            this.documentName = documentName;
            this.documentPreview = process.env.VUE_APP_PUBLIC_URL + url;
            this.showDocumentPreview = true;
        },
        closeDocumentPreview() {
            this.showDocumentPreview = false;
            this.documentName = "";
            this.documentPreview = null;
        },
        getFormattedDateWithTimeAmPm(date) {
            return formattedDateWithTimeAmPm(date);
        },
        getFormattedDate(date) {
            return formattedDate(date);
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 0.5s ease;
}
.form-fade-enter-from,
.form-fade-leave-to {
  opacity: 0;
  height: 0px;
}
</style>